'use client';

import { useAuthStore } from '@/stores/AuthStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

import { getVisibleMenuItems, MENU_ITEMS } from './MenuItems';
import { MyPageMenuSections } from './MyPageMenuSections';
import { ProfileSection } from './ProfileSection';
import { QuickIconGrid } from './QuickIconGrid';

export const DesktopMyPageContent = ({
  isAuthenticated,
}: {
  isAuthenticated: boolean;
}) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const subDomain = useDeviceInfoStore((state) => state.subDomain);
  const isReady = !isAuthenticated || !!isLogin;
  const visibleMenuItems = getVisibleMenuItems(MENU_ITEMS, subDomain);

  return (
    <div className="mx-auto w-full max-w-[600px] overflow-hidden rounded-large border border-Gray-300 bg-Gray-50">
      {isReady ? (
        <div className="duration-300 animate-in fade-in">
          <ProfileSection variant="desktop" />
          <QuickIconGrid variant="desktop" />
        </div>
      ) : (
        <div className="h-300" />
      )}
      <MyPageMenuSections
        visibleMenuItems={visibleMenuItems}
        isReady={isReady}
        variant="desktop"
      />
    </div>
  );
};
